"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_utils_types_1 = require("@gerenciatd/next.utils.types");
const next_utils_request_1 = __importDefault(require("@gerenciatd/next.utils.request"));
class Sonda2 {
    /** TODO: podrá recibir el contexto y tomar los datos de él,
    en lugar de volver a consumirlos del windows, sino jamás podrán ser workers
    * @param {string} eventName nombre del servicio/funciona sondar ej: 'CUSTOMIZER.ACTVITY.GETBYNAME'
    * @param {Context} context Contexto
    * @param {string} uniqueId Identificador unico tipo UUID, para los servicios es obligatorio, para sondar un js no.
    * @param {object} origin Desde donde se utilizan las sondas
    */
    constructor({ eventName, context, uniqueId, origin, }) {
        this.getFinalSondaInfo = (cData, type, eventName, wsEventType, elementType, time) => {
            let sondaInfo = {};
            switch (elementType) {
                case next_utils_types_1.JS_ERROR:
                    sondaInfo = {
                        cData,
                        cdContextInfo: '',
                        cdElementType: elementType || '',
                        cdEnvironment: 'WEB',
                        cdEventName: '',
                        cdEventType: '',
                        // completamos el referer ?
                        cdReferer: '',
                        cdSegment: (this.context && this.context.pageSegment) || 'no_def',
                        cdSource: 'MonitoringUtils',
                        cdTimeStamp: new Date(Date.now()).toISOString(),
                        cdType: 'Error-Handler',
                        cdUrl: (this.context && this.context.contextURL) || '',
                        ctzActivityId: '',
                        ctzExperienceId: '',
                        ctzId: '',
                        ctzPageId: '',
                        ctzTemplateId: '',
                        phCode: '',
                        posCode: '',
                        status: '',
                        uiGAClientId: (this.context &&
                            this.context.clientIDs &&
                            this.context.clientIDs.ga) ||
                            '',
                        wbPageId: (this.context &&
                            this.context.clientIDs &&
                            this.context.clientIDs.pageId) ||
                            '',
                        wbSessionId: (this.context &&
                            this.context.clientIDs &&
                            this.context.clientIDs.sessId) ||
                            '',
                        webCode: '',
                        wsContext: this.origin,
                        wsName: this.eventName, // linea
                    };
                    break;
                default:
                    sondaInfo = {
                        // Traza
                        wbSessionId: (this.context &&
                            this.context.clientIDs &&
                            this.context.clientIDs.sessId) ||
                            '',
                        uiGAClientId: (this.context &&
                            this.context.clientIDs &&
                            this.context.clientIDs.ga) ||
                            '',
                        // Contextual
                        cdContext: this.origin,
                        cdSource: 'MonitoringUtils',
                        cdEnvironment: 'WEB',
                        cdSegment: (this.context && this.context.pageSegment) || 'no_def',
                        cdUserAgent: this.context && this.context.userAgent,
                        cdTimeStamp: time,
                        cdUrl: (this.context && this.context.contextURL) || '',
                        cdReferer: (this.context && this.context.referalAP) || '',
                        // Evento
                        // -> Identificador único.
                        ctzId: this.uniqueId,
                        // -> Tipo ('ws' | 'chat' | 'ctz').
                        cdType: type || '',
                        // -> Nombre del evento.
                        cdEventName: eventName || '',
                        // -> Tipo de Evento solo para WebServices ('Started' | 'Loaded').
                        cdEventType: wsEventType || '',
                        // -> Estado del Evento WebService ('ok', 'error', 'js-error', 'error-timeout').
                        cdElementType: elementType || '',
                        // -> Información adicional (datos)
                        cData: JSON.stringify(cData),
                        // -> Contexto del WebService
                        wsContext: this.origin,
                        // --> Nombre del WebService (El mismo que el del Evento)
                        wsName: eventName || '',
                        // --> Estado del WebService (El mismo que el WSElementType)
                        status: elementType || '',
                    };
            }
            return sondaInfo;
        };
        /**
         * Indica el inicio de solicitud de un WebService/EndPoint invocado desde frontal
         * @param {unknown} info Información asociada al evento que se está sondando
         * @param {Type} type
         */
        this.startWS = ({ info, time }) => {
            this.sendInfoToCtzMetricsData(next_utils_types_1.SondaType.WS, this.eventName, info, time, next_utils_types_1.WSEventType.STARTED);
        };
        /**
         * Indica la finalización de solicitud de un WebService/EndPoint invocado desde frontal
         * @param {WSElementType} status
         * @param {unknown} info Información adicional a enviar
         * @param {Type} type
         */
        this.endWS = ({ status, info, time }) => {
            this.sendInfoToCtzMetricsData(next_utils_types_1.SondaType.WS, this.eventName, info, time, next_utils_types_1.WSEventType.LOADED, status);
        };
        this.eventName = eventName;
        this.origin = origin || 'ADABYRON-API';
        this.context = context;
        this.uniqueId = uniqueId;
    }
    /**
     * Realiza la petición al endpoint de sondas
     * @param {SondaType} type
     * @param {string} eventName Nombre del evento
     * @param {unknown} info Información asociada al evento que se está sondando
     * @param {WSEventType} wsEventType
     * @param {(WSElementType|string)} elementType -
     */
    sendInfoToCtzMetricsData(type, eventName, info, time, wsEventType, elementType) {
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        const isFrontApp = typeof window !== 'undefined';
        // si estoy en cliente (window) y estoy en dev obligo al parametro
        const isShowSondaEnableDev = isFrontApp &&
            currentEnv === 'dev' &&
            window.location.search.indexOf('showSonda') > -1;
        // si estoy en qa o prod y en cliente lo enseño
        const isShowSondaEnableQaProd = isFrontApp && currentEnv !== 'dev';
        if (isShowSondaEnableDev || isShowSondaEnableQaProd) {
            try {
                const endPoint = 'https://europe-west1-mov-prod10.cloudfunctions.net/export-customizer-data-metrics';
                const headers = {
                    timeout: 6000,
                    'Content-Type': 'application/json',
                };
                let cData = { idPeticion: this.uniqueId };
                if (info && typeof info === 'object') {
                    cData = Object.assign(Object.assign({}, cData), info);
                }
                else {
                    cData.info = info;
                }
                const sondaInfo = this.getFinalSondaInfo(cData, type, eventName, wsEventType, elementType, time);
                const request = new next_utils_request_1.default({
                    method: next_utils_types_1.MethodType.POST,
                    endpoint: endPoint,
                    beacon: true,
                    data: sondaInfo,
                    headers,
                });
                request.makeRequest();
            }
            catch (e) {
                this.errorJs(e);
            }
        }
    }
    /**
     * Indica el inicio de solicitud de un WebService/EndPoint invocado desde frontal
     * @param {unknown} info Información asociada al evento que se está sondando
     * @param {Type} type
     */
    startExternalFlow(info, time) {
        this.sendInfoToCtzMetricsData(next_utils_types_1.SondaType.EXTERNAL_FLOW, this.eventName, info, time, next_utils_types_1.WSEventType.STARTED);
    }
    /**
     * Indica la finalización de solicitud de un WebService/EndPoint invocado desde frontal
     * @param {WSElementType} status
     * @param {unknown} info Información adicional a enviar
     * @param {Type} type
     */
    endExternalFlow(status, info, time) {
        this.sendInfoToCtzMetricsData(next_utils_types_1.SondaType.EXTERNAL_FLOW, this.eventName, info, time, next_utils_types_1.WSEventType.LOADED, status);
    }
    /**
     * Envía información de un evento concreto a las sondas
     * @param {unknown} info - Información adicional del evento, puede ser un JSON, un String...
     * @param {Type} type
     */
    sondaEvent(info, type = next_utils_types_1.SondaType.EVENT) {
        this.sendInfoToCtzMetricsData(type, this.eventName, info, new Date(Date.now()).toISOString());
    }
    /**
     * Envía información de un error concreto a las sondas
     * @param jsError Excepción tipicamente capturada en los catch de JS
     *
     */
    errorJs(jsError) {
        try {
            if (jsError !== undefined) {
                const errorInfo = `${typeof jsError.stack !== 'undefined' ? jsError.stack : jsError}`;
                this.sendInfoToCtzMetricsData(next_utils_types_1.SondaType.ERROR_HANDLER, this.context.contextURL, errorInfo, '', null, next_utils_types_1.JS_ERROR);
            }
        }
        catch (e) {
            // console.error("Sonda.errorJs - ", e);
        }
    }
}
exports.default = Sonda2;
//# sourceMappingURL=index.js.map